import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from "react-router-dom";
import App from './pages/App';
import * as serviceWorker from './serviceWorkerController/serviceWorker';
import { I18nextProvider } from 'react-i18next';
import './styles/font-face.css';
import { baseRouter } from './utilities/constants';
import i18n from './i18n';

ReactDOM.render(
  <HashRouter basename={baseRouter}>
    <I18nextProvider i18n={i18n}>
    <App />
  </I18nextProvider>
  </HashRouter>,
  document.getElementById('root')
);

// serviceWorker.register();